import React, { useCallback, useEffect, useState } from "react";
import "./MarketingHero.css";

const API_BASE = (process.env.REACT_APP_API_BASE || "http://localhost:5000").replace(
  /\/+$/,
  ""
);

const defaultStats = {
  totalLeads: 0,
  newsletterCount: 0,
  contactSalesCount: 0,
};

function MarketingHero() {
  const [stats, setStats] = useState(defaultStats);
  const [loading, setLoading] = useState(false);

  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);

      const response = await fetch(`${API_BASE}/api/marketing/stats`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok || !data?.success) {
        throw new Error(data?.message || "Failed to fetch marketing stats.");
      }

      setStats({
        totalLeads: Number(data?.data?.totalLeads || 0),
        newsletterCount: Number(data?.data?.newsletterCount || 0),
        contactSalesCount: Number(data?.data?.contactSalesCount || 0),
      });
    } catch (error) {
      console.error("Failed to fetch marketing stats:", error);
      setStats(defaultStats);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStats();

    window.addEventListener("marketing-lead-created", fetchStats);

    return () => {
      window.removeEventListener("marketing-lead-created", fetchStats);
    };
  }, [fetchStats]);

  const handleScroll = (event, selector) => {
    event.preventDefault();

    const target = document.querySelector(selector);

    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section className="marketing-hero-section">
      <div className="marketing-container">
        <div className="marketing-hero-layout">
          <div className="marketing-hero-content">
            <span className="marketing-hero-badge">Marketing Growth</span>

            <h1 className="marketing-hero-title">Grow Your Brand Online</h1>

            <p className="marketing-hero-text">
              Boost your visibility, connect with more customers, and promote your
              business with powerful SEO, email campaigns, and brand marketing tools.
            </p>

            <div className="marketing-hero-actions">
              <a
                href="#marketing-newsletter-form"
                className="marketing-primary-btn marketing-btn-link"
                onClick={(event) => handleScroll(event, "#marketing-newsletter-form")}
              >
                Start Marketing
              </a>

              <a
                href="#marketing-how-it-works"
                className="marketing-secondary-btn marketing-btn-link"
                onClick={(event) => handleScroll(event, "#marketing-how-it-works")}
              >
                View Process
              </a>
            </div>

            <div className="marketing-trust-row">
              <span>📈 SEO Growth</span>
              <span>📩 Email Campaigns</span>
              <span>🎯 Lead Generation</span>
            </div>
          </div>

          <div className="marketing-hero-dashboard">
            <div className="marketing-dashboard-card">
              <div className="marketing-dashboard-top">
                <div>
                  <span>Live Overview</span>
                  <h3>Marketing Leads</h3>
                </div>
                <div className="marketing-dashboard-icon">🚀</div>
              </div>

              <div className="marketing-stats-row">
                <div className="marketing-stat-card">
                  <h3>{loading ? "..." : stats.totalLeads}</h3>
                  <p>Total Leads</p>
                </div>

                <div className="marketing-stat-card">
                  <h3>{loading ? "..." : stats.newsletterCount}</h3>
                  <p>Newsletter</p>
                </div>

                <div className="marketing-stat-card">
                  <h3>{loading ? "..." : stats.contactSalesCount}</h3>
                  <p>Sales Requests</p>
                </div>
              </div>

              <div className="marketing-mini-progress">
                <div>
                  <span>SEO Campaign</span>
                  <strong>82%</strong>
                </div>
                <div className="marketing-progress-bar">
                  <span style={{ width: "82%" }}></span>
                </div>
              </div>

              <div className="marketing-mini-progress">
                <div>
                  <span>Email Outreach</span>
                  <strong>64%</strong>
                </div>
                <div className="marketing-progress-bar">
                  <span style={{ width: "64%" }}></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MarketingHero;